// src/components/modals/OrderHistoryModal.js

import React from 'react';

function OrderHistoryModal({ order, onClose }) {
  // Función para formatear la fecha y hora
  const formatTimestamp = (isoString) => {
    if (!isoString) return 'N/A';
    try {
      const date = new Date(isoString);
      return date.toLocaleString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    } catch (e) {
      console.error("Error formatting timestamp:", isoString, e);
      return isoString; // Retorna el string original si hay error
    }
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <h2 style={{ textAlign: 'center', color: 'var(--secondary-blue)', marginBottom: '20px' }}>
          Historial de Pedido: {order.orderNumber}
        </h2>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '30px' }}>
          Cliente: {order.clientName} - Contacto: {order.contactName} - Teléfono: {order.contactPhone}
          <br />
          Dirección Original: {order.deliveryAddress}
        </p>

        {order.statusHistory && order.statusHistory.length > 0 ? (
          <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '8px', padding: '15px' }}>
            {order.statusHistory.map((entry, index) => (
              <div key={index} style={{
                marginBottom: '15px',
                padding: '10px 15px',
                backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff',
                borderRadius: '8px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                borderLeft: '4px solid var(--secondary-blue)'
              }}>
                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: 'var(--secondary-blue)' }}>
                  Estado: {entry.status}
                </p>
                <p style={{ margin: '0 0 5px 0', fontSize: '0.9em', color: '#555' }}>
                  Fecha/Hora: {formatTimestamp(entry.timestamp)}
                </p>
                <p style={{ margin: '0', fontSize: '0.9em', color: '#555' }}>
                  Actualizado por: {entry.user}
                </p>
                {/* Mostrar información de transporte si está disponible en el historial */}
                {entry.dispatchType && (
                  <p style={{ margin: '5px 0 0 0', fontSize: '0.85em', color: '#777' }}>
                    Tipo de Despacho: {entry.dispatchType}
                  </p>
                )}
                {entry.dispatchDeliveryAddress && ( // Muestra la dirección de despacho del historial
                  <p style={{ margin: '5px 0 0 0', fontSize: '0.85em', color: '#777' }}>
                    Dirección Despacho: {entry.dispatchDeliveryAddress}
                  </p>
                )}
                {entry.driverName && entry.vehiclePlate && (
                  <p style={{ margin: '5px 0 0 0', fontSize: '0.85em', color: '#777' }}>
                    Transporte: {entry.driverName} ({entry.vehiclePlate})
                  </p>
                )}
                {/* Mostrar información de agencia si está disponible en el historial */}
                {entry.agencyTrackingNumber && (
                  <p style={{ margin: '5px 0 0 0', fontSize: '0.85em', color: '#777' }}>
                    Agencia: {entry.agencyName} (Tracking: {entry.agencyTrackingNumber})
                  </p>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p style={{ textAlign: 'center', color: '#666' }}>No hay historial de estados para este pedido.</p>
        )}

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }}>
          <button onClick={onClose} style={{ backgroundColor: 'var(--primary-red)', color: 'white', padding: '10px 20px' }}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalContentStyle = {
  backgroundColor: 'white',
  padding: '30px',
  borderRadius: '10px',
  boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
  width: '90%',
  maxWidth: '650px',
  maxHeight: '90vh',
  overflowY: 'hidden',
  position: 'relative',
};

export default OrderHistoryModal;